import { LOGIN_METHOD_OVERRIDE } from '@/config/env';

export type LoginMode = 'password' | 'otp';

/**
 * Apex (no workspace slug) → password login (owners). A workspace subdomain →
 * OTP login (members). Owners on a subdomain use the apex escape-hatch link.
 *
 * `VITE_LOGIN_METHOD` (local dev) overrides this on every origin, so OTP or
 * password login can be forced from env without a code change.
 */
export function loginMode(slug: string | null): LoginMode {
  if (LOGIN_METHOD_OVERRIDE) return LOGIN_METHOD_OVERRIDE;
  return slug ? 'otp' : 'password';
}
